module.exports = __webpack_public_path__ + "img/disableadd.3b962956.svg";